import {useContext, useLayoutEffect, useRef} from "react";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ThemeContext} from "../../container/Landing";

gsap.registerPlugin(ScrollTrigger)
export default function ProfileImage() {
  const imageRef = useRef(null)
  const isTouch = "ontouchstart" in document.documentElement;
  const ProfileDark = new Image();
  ProfileDark.src = '/images/ProfileDark.jpg';

  const ProfileLight = new Image();
  ProfileLight.src = '/images/ProfileLight.jpg';

  useLayoutEffect(() => {
    const _gsap = gsap.to(imageRef.current, {
      scrollTrigger: {
        trigger: imageRef.current,
        start: "30% bottom",
        // toggleActions: "play pause resume reverse",
        toggleActions: "play none none none",
      },
      opacity: 1,
      ease: "power2.out",
      duration: 2,
      delay: 0.6,
    });
    return () => _gsap.kill()
  }, [imageRef, isTouch])

  const theme = useContext(ThemeContext)

  return (
      <div className='max-h-[500px] md:h-auto'>
        {theme === 'dark' ?
            <img
                ref={imageRef}
                 className={'myImage opacity-0'}
                 src={ProfileDark.src}
                 alt=""
                 style={{filter: 'opacity(0.9)', objectFit: 'cover'}}
            />
            :
            <img
                ref={imageRef}
                className={'myImage opacity-0'}
                src={ProfileLight.src}
                alt=""
                style={{filter: 'opacity(0.7)', objectFit: 'cover', grayscale: '100%'}}
            />
        }
      </div>
  )
}
